















































































































































































































































import { Component, Provide, Vue } from "vue-property-decorator";
import { timeFormat } from "@/utils";
import {
  ticketClient,
  authorClient,
  client,
  collectionServiceClient,
} from "@/api/index";
import {
  SaveOcrMarkCaseReq,
  OcrMarkTicket,
} from "@/pbjs/xcommon/collection_pb.js";
import { errorMsg, setCommon } from "@/utils/request";
@Component({
  name: "imgDetail",
})
export default class imgDetail extends Vue {
  @Provide() private temp: any = ""; //
  @Provide() private via: any = null; //
  @Provide() private resultData: any = [];
  @Provide() private resultmark: any = "";
  @Provide() private ticktid: any = "";
  @Provide() private disable: boolean = false;
  @Provide() private nextdisable: boolean = true;
  @Provide() private nextticketid: any = "";
  private created() {
    const s = document.createElement("script");
    // s.setAttribute('id','ViaViaVia')
    s.type = "text/javascript";
    s.src = "via.js";
    document.getElementsByTagName("head")[0].appendChild(s);
    setTimeout(() => {
      if (this.$route.query.ticketstatus=='已完成') {
         this.disable=true
      }
        this.getOcrMarkCase();
    }, 400);
    // 微  promise aysnc/await（ES7，koa 2） generate（ES6，koa 1） nextTick process
    // express -> koa
    // 宏 script setTimeout setInterval setImmediate
    // 同步任务， Event Queue(Micro task),  Event Table, （订阅、发布）  同步任务的执行栈空了，Event Queue 推入Event Table中注册事件，微任务空了；推入EventTable的宏任务， 执行下一轮次的任务
  }
  //保存标注信息
  private saveMetaData(val: any) {
    this.via.s.get_mate_data();
    let _via_share: any = localStorage.getItem("_via_share");
    let data = JSON.parse(_via_share);
    let metadata = JSON.stringify(data.metadata);
    if (val==0) {
      setTimeout(async () => {
      this.$message(this.$tc('dashbordDy.Currentlythelastorder'))
      }, 300);
    }else{
      if (metadata) {
      let nextmeta: any = localStorage.getItem("nextmeta");
      let data_nextmeta = JSON.parse(nextmeta);
      
      let request = new SaveOcrMarkCaseReq();
      let requestAuto: any = new OcrMarkTicket();
      request.setCommonin(setCommon());
      request.setTicketid(Number(this.ticktid));
      requestAuto.setTicketid(Number(this.ticktid));
      // requestAuto.setTicketid(106);
      requestAuto.setMarkresult(metadata);
      requestAuto.setMarkstatus(val);
      request.setData(requestAuto);
      collectionServiceClient.saveOcrMarkCase(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            let data = response.toObject();
            if (data.commonout.code == 0) {
              this.$message.success('id:' +this.ticktid+  'success');
              this.disable = true;
              this.nextTick()
            } else {
              this.disable = true;
              this.$message.error(data.commonout.errmsg);
            }
          }
          if (err) {
            errorMsg(err);
          }
        }
      );
    }
    }
    
  }

  private mounted() {}
  private nextTick() {
    if (this.nextticketid==0) {
      setTimeout(async () => {
      this.$message(this.$tc('dashbordDy.Currentlythelastorder'))
      }, 300);
      this.disable=true
    }else{
       let obj: any = localStorage.getItem("nextmeta");
       let nextmeta = JSON.parse(obj);
       let imageData = "data:image/jpeg;base64," + nextmeta.data.imgbody;
       // this.resultmark = data.data.markresult?'1':data.data.originresult?'2':
       let metadata: any;
       if (nextmeta.data.markresult) {
         metadata = nextmeta.data.markresult;
       } else if (nextmeta.data.originresult) {
         metadata = nextmeta.data.originresult;
       }
       this.ticktid=nextmeta.data.ticketid
       //直接展示已有的metadata
       this.loadMetaData(imageData, metadata, nextmeta.data.markattribute, true);
       // 请求获取下一单id
       this.nextticketid=nextmeta.data.nextticketid
       this.getnextticket(nextmeta.data.nextticketid);
       this.disable=false
    }  
  }

  private destroyed() {}

  // 加载工单数据
  private async getOcrMarkCase() {
    
    const { setGetOcrMarkCaseReq, getOcrMarkCaseRequest }: any = await import(
      "@/request/getOcrMarkData"
    );
    let data = await getOcrMarkCaseRequest.handleHttp(
      setGetOcrMarkCaseReq({
        ticketId: Number(this.$route.query.id),
      }),
      this
    );
    let imageData = "data:image/jpeg;base64," + data.data.imgbody;
    let metadata: any;
    if (data.data.markresult) {
      metadata = data.data.markresult;
    } else if (data.data.originresult) {
      metadata = data.data.originresult;
    }
    this.ticktid = data.data.ticketid;
    this.loadMetaData(imageData, metadata, data.data.markattribute);
    this.nextticketid = data.data.nextticketid;
    this.getnextticket(this.nextticketid);
  }

  //获取下一单
  private async getnextticket(id: any) {
    if (id!==0) {
    const { setGetOcrMarkCaseReq, getOcrMarkCaseRequest }: any = await import(
      "@/request/getOcrMarkData"
    );
    let data = await getOcrMarkCaseRequest.handleHttp(
      setGetOcrMarkCaseReq({
        ticketId: Number(id),
      }),
      this
    );
    let imageData = "data:image/jpeg;base64," + data.data.imgbody;
    let metadata: any;
    if (data.data.markresult) {
      metadata = data.data.markresult;
    } else if (data.data.originresult) {
      metadata = data.data.originresult;
    }
    if (metadata) {
      localStorage.setItem("nextmeta", JSON.stringify(data));
    }
    }
  }

  //加载属性配置项和标注信息
  private loadMetaData(
    imageData: string,
    originresult: string,
    attribute: string,
    isNext?: boolean
  ) {
    // let via_container: any = null;

    setTimeout(async () => {
      if (isNext) {
        if (document.getElementById("via_container")) {
          let obj: any = document.getElementById("via_container");
          obj.parentNode.removeChild(obj);
        }
        let temp: any = document.createElement("div");
        temp.setAttribute("id", "via_container");
        temp.className = "via_container";
        (document.getElementById("box") as any).appendChild(temp);
      }
      let via_container = document.getElementById("via_container");
      let initData = {
        imgsrc: imageData,
        //项目属性配置项
        attribute: attribute ? JSON.parse(attribute) : {},
        //标注信息
        metadata: originresult ? JSON.parse(originresult) : {},
        // "imgsrc":"https://m.guojimami.com/themesmobile/mbts1/images/shenfen0813_01.jpg",
        // //项目属性配置项
        // "attribute":{"1":{"aname":"aaaa","anchor_id":"FILE1_Z0_XY1","type":1,"desc":"","options":{},"default_option_id":""},"2":{"aname":"bbbb","anchor_id":"FILE1_Z0_XY1","type":1,"desc":"","options":{},"default_option_id":""},"3":{"aname":"cccc","anchor_id":"FILE1_Z1_XY1","type":1,"desc":"","options":{},"default_option_id":""},"4":{"aname":"dddd","anchor_id":"FILE1_Z2_XY0","type":1,"desc":"","options":{},"default_option_id":""},"5":{"aname":"eeee","anchor_id":"FILEN_Z0_XY0","type":1,"desc":"","options":{},"default_option_id":""}},
        // //标注信息
        // "metadata":{"2_WIpRNLvX":{"vid":"2","flg":0,"z":[],"xy":[2,378.921,121.113,84.991,234.435],"av":{"1":"Socrates","2":"Death of Socrates painting by David."}},"2_eA5CqEPf":{"vid":"2","flg":0,"z":[],"xy":[2,198.314,150.152,109.072,238.684],"av":{"1":"Plato"}},"1_7cXLgtK7":{"vid":"1","flg":0,"z":[],"xy":[2,301.58896,149.6193,173.903,54.051],"av":{}},"1_7khLn280":{"vid":"1","flg":0,"z":[],"xy":[2,301.589,252.238,54.834,54.835],"av":{}},"1_aAQFvQ7O":{"vid":"1","flg":0,"z":[],"xy":[2,599.261,253.805,56.401,57.968],"av":{}},"1_a7TtsTi3":{"vid":"1","flg":0,"z":[],"xy":[2,318.823,358.774,113.585,45.434],"av":{}},"1_ercUC8Zy":{"vid":"1","flg":0,"z":[],"xy":[2,312.556,459.825,401.858,50.918],"av":{}},"1_rzmXseFw":{"vid":"1","flg":0,"z":[],"xy":[2,545.994,727.731,718.33,50.917],"av":{}}}
      };
      this.via = new Via(via_container, initData);
    }, 300);
  }
}
